<template>
  <modal>
    <modal-inner>
      <div class="w-full flex justify-end">
        <div @click="onClose($event)" @touchend="onClose($event)">
          <icon-circle-reject class="text-3xl" />
        </div>
      </div>

      <div
        class="pop-up-box-title flex justify-center align-middle text-contrast-light content-center text-center"
      >
        <h2
          class="flex-grow text-chplus-title-tutorial font-bold uppercase self-center"
        >
          {{ title }}
        </h2>
      </div>

      <content-scroll-container class="h-full" v-bind:flex="true">
        <content-scroll-inner
          class="h-full survey-text w-full h-full text-chplus-regular flow-text"
        >
          <slot></slot>
        </content-scroll-inner>
      </content-scroll-container>
    </modal-inner>
  </modal>
</template>

<script>
import ContentScrollContainer from "./ContentScrollContainer";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";
import Modal from "@/components/layouts/Modal";
import ModalInner from "@/components/layouts/ModalInner";
import IconCircleReject from "../icons/IconCircleReject.vue";

export default {
  name: "PopUp",
  components: {
    ModalInner,
    Modal,
    ContentScrollInner,
    ContentScrollContainer,
    IconCircleReject
  },
  props: {
    title: {
      type: String,
      default: "Title"
    }
  },
  methods: {
    onClose(event) {
      // Deduplicate touchend and click events
      if (process.env.VUE_APP_PLATFORM === "ios") {
        if (event.type !== "touchend") {
          return;
        }
      } else if (event.type !== "click") {
        return;
      }

      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ .content-scroll-inner {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.survey-text p {
  word-break: break-word;
  hyphens: auto;
}

.pop-up-box-title {
  min-height: 4.312rem;
}

@media screen and (min-width: 768px) {
  .pop-up-box-title {
    min-height: 5.12rem;
  }
}
</style>
